import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GaTracker — fires a Google Analytics 4 `page_view` event on every
 * client-side route change.
 *
 * The base gtag.js script in /public/index.html fires the initial pageview
 * automatically. This component covers the React Router transitions that
 * gtag would otherwise miss (since the SPA never reloads the document).
 *
 * Mounted once at <App> root — no per-page wiring needed for new pages.
 */
export default function GaTracker() {
  const loc = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    try {
      const path = loc.pathname + (loc.search || "");
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    } catch { /* never block rendering */ }
  }, [loc.pathname, loc.search]);

  return null;
}
